import { BellElectric, BotMessageSquare, CheckCheck, CornerDownRight, LayoutGrid, ListChecks, Minus, MoveLeft, MoveRight, Pencil, Play, Plus, StepBack, StepForward, X } from "lucide-react";
import React, { useEffect, useState,useRef } from "react";
import fallback_img from "../img/fallback_img.jpg"
import loading_img from "../img/loadingImg.jpg"
import ScrollTransformWrapper from "../../DesignElements/hook/ScrollTransformWrapper";
import YoutubeVideoPlayerWebUI from "../../../../UI/YoutubeVideoPlayerWebUI";
import TrimmedTextUI from "./TrimmedTextUI";

const   Theme1InfoCard2 = ({ setCurrentContentIndex,currentIndex,
  CurrentObject ,
  setCurrentObject, setHideReduUnDo, moveItemUp,moveItemDown,deleteItem,duplicateItem,duplicateContentsItem,item ,dynamicId,
    
}) =>{
   

//   const CurrentObject =   { no:3, 
//     id: generateTimestamp()+3,
//     cardName:"Theme1InfoCard2",
//     cardType:"non-Editable",
//  myKey:`id-Theme1InfoCard2-layout`,
//   blockType:"layout",
//     contents:[
//     { contentNo:1, id: generateTimestamp(),itemBackground:{color:"rgba(0, 0, 0, 1)",alpha:1}
//           ,itemCards:{  type:"nonEditable"
//             ,cards:[
//                        ]},myKey:`id-Theme1InfoCard2-layout1`,
//           columns:1,fontFamily:{name:"OpenSans-Regular",
//   fontFamily:"OpenSansRegular , sans-serif"
//  },
//   blockType:"Card",
//  innerBlocks:[],

//  customStyle:{
    
//  },
//  layoutSettings:{
//     disableAnimation:false,
//      shape1Animation:{title:"Shape Animation",type:"rhombusHL",delay:0.4,
//         color: {color:"rgba(35, 36, 36, 0.93)",color1:"rgba(130, 242, 242, 0.93)",color2:"rgba(140, 177, 251, 0.93)",colors:{color10:"rgba(247, 252, 252, 0.93)"},alpha:1}
//      ,},
//       shape2Animation:{title:"Shape Animation",type:"rhombusHR",delay:0.4,
//         color:{color:"rgba(255, 255, 255, 0.93)",color1:"rgba(130, 242, 242, 0.93)",color2:"rgba(140, 177, 251, 0.93)",colors:{color10:"rgba(247, 252, 252, 0.93)"},alpha:1}
//      , },
     
//      layoutWidth:{value:100,resolution:"%"},
    
//      borderRadius1:{title:"Layout BG Radius",value:0,resolution:"px"},
    
//      layoutBG:{ title:"Section Card Outer Color",
//       color:"rgba(255, 255, 255, 1)",colors:{color3:"rgba(255, 224, 71, 0.3)",color10:"rgba(255, 224, 71, 1)"},alpha:1},
    
//  }   },
//         { contentNo:2, id: generateTimestamp()+1,itemBackground:{color:"rgba(144, 202, 249, 0.1)",alpha:1}

//           ,itemCards:{  type:"nonEditable"
//             ,cards:[
//                { id: 1,hideImage: false,hideTitle: false,hideSubtitle: false, hideVideo: false, hideButtons: false,  
//                 title: "Master the Art of Music",subtitle: "Unlock your musical potential with this comprehensive course. Learn theory, rhythm, melody, and composition across styles. ", 
//                 image: "https://i.postimg.cc/fb0Gq22L/cheerful-student-posing-against-pink-wall-with-glasses.jpg",
//                 video:{
//                            playerTheme:"Classic",// Classic, Modern 
//                            sourceType:"youtube",// 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) 
//                            youtube:{src:"https://www.youtube.com/watch?v=qFLhGq0060w",
//                            showDefaultThumbnail:true
//                            ,useDefaultPlayer:false },
//                             vimeo:{src:"https://vimeo.com/837164312"
//                            ,useDefaultPlayer:false},
//                             mp4URL:{src:"" },
//                             uploadedVideoURL:{src:"" },
//                             videoThumbnail:{
//                                 src:"",hideThumbnail:false,
//                                             },
//                             videoPlayButton:{
//                                      playButtonBorderRadius:{value:0,resolution:"px"} ,
//                                      playButtonColor:{normal:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},hover:{}} ,
//                                      playIconColor:{normal:{},hover:{}}  ,
                                    
//                                      onClickActionArray:[{title:"Play Video",value:"playVideo"},
//                                      {title:"Pop Up Video",value:"popUpVideo"},{title:"Open Lead Form",value:"popUpLeadForm"}],
//                                     // popUpLeadFormBeforePlay- set status in cookie
//                                      onClickAction:"playVideo",// 
//                                      popUpLeadForm:{
//                                      delay:10,sendLeadInfoToEmail:{email:""},
//                                      showFields:{name:true,email:true,mobile:true,city:false,
//                                     //  custom:[{fieldName:"Any Name",status:false}]
//                                     }
//                                       }, 
//                                      popUpVideo:{ showOnlyPlayButton:false },
                                    
//                                           }
//                                        }, },
//               { id: 2,hideImage: false,hideTitle: false,hideSubtitle: false, hideVideo: false, hideButtons: false,
//                   title: " Learn, Play, Create",subtitle: "Explore the world of music through engaging lessons in theory, instruments, and composition. This course is designed for all levels to build a strong musical foundation, improve performance skills, and inspire creativity.", 
//                 image: "https://i.postimg.cc/Y0jf8VRD/young-smiling-student-woman-white-background.jpg" ,
//                video:{
//                            playerTheme:"Classic",// Classic, Modern 
//                            sourceType:"youtube",// 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) 
//                            youtube:{src:"https://www.youtube.com/watch?v=Bn-3ICGjz0U",
//                            showDefaultThumbnail:true
//                            ,useDefaultPlayer:false },
//                             vimeo:{src:"https://vimeo.com/837164312"
//                            ,useDefaultPlayer:false},
//                             mp4URL:{src:"" },
//                             uploadedVideoURL:{src:"" },
//                             videoThumbnail:{
//                                 src:"",hideThumbnail:false,
//                                             },
//                             videoPlayButton:{
//                                      playButtonBorderRadius:{value:0,resolution:"px"} ,
//                                      playButtonColor:{normal:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},hover:{}} ,
//                                      playIconColor:{normal:{},hover:{}}  ,
                                    
//                                      onClickActionArray:[{title:"Play Video",value:"playVideo"},
//                                      {title:"Pop Up Video",value:"popUpVideo"},{title:"Open Lead Form",value:"popUpLeadForm"}],
//                                     // popUpLeadFormBeforePlay- set status in cookie
//                                      onClickAction:"playVideo",// 
//                                      popUpLeadForm:{
//                                      delay:10,sendLeadInfoToEmail:{email:""},
//                                      showFields:{name:true,email:true,mobile:true,city:false,
//                                     //  custom:[{fieldName:"Any Name",status:false}]
//                                     }
//                                       }, 
//                                      popUpVideo:{ showOnlyPlayButton:false },
                                    
//                                           }
//                                        },},
//               { id: 3,hideImage: false,hideTitle: false,hideSubtitle: false, hideVideo: false, hideButtons: false,
//                   title: "Learn at Your Pace",subtitle: "Master the basics of music with a blend of theory, practice, and creativity. Perfect for learners of all ages, this course helps you develop your musical voice through structured yet inspiring lessons.", 
//                 image: "https://i.postimg.cc/g2v3W5z5/red-haired-lady-eyeglasses-holds-books-shows-ok-sign.jpg",
//                 video:{
//                            playerTheme:"Classic",// Classic, Modern 
//                            sourceType:"youtube",// 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) 
//                            youtube:{src:"https://www.youtube.com/watch?v=UZwi9SHgzGY",
//                            showDefaultThumbnail:true
//                            ,useDefaultPlayer:false },
//                             vimeo:{src:"https://vimeo.com/837164312"
//                            ,useDefaultPlayer:false},
//                             mp4URL:{src:"" },
//                             uploadedVideoURL:{src:"" },
//                             videoThumbnail:{
//                                 src:"",hideThumbnail:false,
//                                             },
//                             videoPlayButton:{
//                                      playButtonBorderRadius:{value:0,resolution:"px"} ,
//                                      playButtonColor:{normal:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},hover:{}} ,
//                                      playIconColor:{normal:{},hover:{}}  ,
                                    
//                                      onClickActionArray:[{title:"Play Video",value:"playVideo"},
//                                      {title:"Pop Up Video",value:"popUpVideo"},{title:"Open Lead Form",value:"popUpLeadForm"}],
//                                     // popUpLeadFormBeforePlay- set status in cookie
//                                      onClickAction:"playVideo",// 
//                                      popUpLeadForm:{
//                                      delay:10,sendLeadInfoToEmail:{email:""},
//                                      showFields:{name:true,email:true,mobile:true,city:false,
//                                     //  custom:[{fieldName:"Any Name",status:false}]
//                                     }
//                                       }, 
//                                      popUpVideo:{ showOnlyPlayButton:false },
                                    
//                                           }
//                                        }, },
                  
//                        ]},myKey:`id-Theme1InfoCard2-layout2`,columns:4,fontFamily:{name:"OpenSans-Regular",
//   fontFamily:"OpenSansRegular , sans-serif"
//  },
//   blockType:"images",
//  customStyle:{
    
//  },
//  layoutSettings:{
//     flexDirection:"row",
   
//     gap:10,
//     flexWrap:"nowrap",
//     justifyContent:"center",
//     alignItems:"center",
//     layoutWidth:{value:100,resolution:"%"},
// item1Width:{value:60,resolution:"%"},
// item2Width:{value:40,resolution:"%"},

//     disableAnimation:false,
//      layoutAnimation:{title:"Layout Animation",type:"zoomIn",delay:0.4},
//   item1Animation:{title:"Title   Animation",type:"goLeft",delay:0.4},
//   item2Animation:{title:"Subtitle  Animation",type:"goRight",delay:0.4},
//    item3Animation:{title:"Image  Animation",type:"zoomIn",delay:0.4},
//   item4Animation:{title:"Slide Number Animation",type:"spinLeft",delay:0.4},
//   item5Animation:{title:"Slide Carousel Animation",type:"slideRightRotate",delay:0.4},
//   item6Animation:{title:"Text Card Animation",type:"zoomIn",delay:0.4},
   
//      borderRadius1:{title:"Layout Radius",topLeft:{title:"Text Box Radius",value:150,resolution:"px"},topRight:{title:"Text Box Radius",value:10,resolution:"px"},
//     bottomLeft:{title:"Text Box Radius",value:30,resolution:"px"},bottomRight:{title:"Text Box Radius",value:50,resolution:"px"}},
//      borderRadius2:{title:"Play Button Radius",topLeft:{title:"Text Box Radius",value:50,resolution:"px"},topRight:{title:"Text Box Radius",value:50,resolution:"px"},
//     bottomLeft:{title:"Text Box Radius",value:50,resolution:"px"},bottomRight:{title:"Text Box Radius",value:50,resolution:"px"}},
//     borderRadius3:{title:"Image Carousel Radius",topLeft:{title:"Text Box Radius",value:0,resolution:"px"},topRight:{title:"Text Box Radius",value:10,resolution:"px"},
//     bottomLeft:{title:"Text Box Radius",value:0,resolution:"px"},bottomRight:{title:"Text Box Radius",value:30,resolution:"px"}},
//      item1AspectRatio:{title:"Image 2 Crop Ratio",value:4/2},
//     //  borderRadius2:{title:"Title BG Radius",value:10,resolution:"%"},
//     //  borderRadius3:{title:"Subtitle BG Radius",value:10,resolution:"%"},
   
//     layoutBG:{title:"Layout Background Color",color:"rgba(253, 253, 253, 1)",colors:{color10:"rgba(253, 253, 253, 1)"},alpha:1},
//      item1BG:{title:"Slide & Title Background Color",color:"rgba(252, 142, 74, 1)",colors:{color10:"rgba(252, 142, 74, 1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},
//         item2BG:{title:"Carousel Background Color",color:"rgba(252, 187, 74, 1)",colors:{color10:"rgba(252, 187, 74,1)"},alpha:1},
// margin:{
//   title:"Set Text Box Card  Margin",
//   marginTop:{title:"Top Margin",value:80,resolution:"px"},
//   marginLeft:{title:"Left Margin",value:30,resolution:"px"},
//   marginRight:{title:"Right Margin",value:30,resolution:"px"},
//   marginBottom:{title:"Bottom Margin",value:30,resolution:"px"}},
// marginItem1:{ title:"Set Title Margin",
//   marginTop:{title:"Top Margin",value:1,resolution:"px"},
//   marginLeft:{title:"Left Margin",value:15,resolution:"px"},
//   marginRight:{title:"Right Margin",value:50,resolution:"px"},
//   marginBottom:{title:"Bottom Margin",value:150,resolution:"px"}},
//  typographyTitle:{
//          titleColor:{title:"Title Text Color",color:"rgba(245, 236, 236, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},
    
//         size:{title:"Title Text Font Size",value:25,resolution:"px"},
//         family:{name:"OpenSans-Regular",
//     fontFamily:"OpenSansRegular , sans-serif"
//        },
//         weight:{title:"Title Text Font Weight",fontWeight:"900"},
//         textAlignment:{title:"Title Text Alignment",textAlign:"left"},
//         textCase:{title:"Title Text Case",textTransform:"uppercase"},
//        textStyle:{title:"Title  Text Style",textStyle:"italic"},
//        decoration:{title:"Title Text Decoration",line:"",style:"solid", decorationColor :{title:"Title Text Decoration Color",color:"rgba(246, 240, 240, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},thickness:{title:"Title Text Decoration Thickness",value:5,resolution:"px"}},
//        lineHeight:{title:"Title Text Line Height",value:60,resolution:"px"},
//        letterSpacing:{title:"Title Text Letter Spacing",value:1,resolution:"px"},
//        wordSpacing:{title:"Title Text Word Spacing",value:10,resolution:"px"},
//        textStroke:{ 
//          strokeColor:{title:"Title Text Stroke Color",color:"rgba(251, 247, 247, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},
//          strokeSize:{title:"Title Text Stroke Size",value:2,resolution:"px"},
       
//               } ,
//                   textShadow:{title:"Title  Text Shadow",horizontal:{title:"Title Shadow Horizontal",value:10,resolution:"%"},vertical:{title:"Title Shadow Vertical",value:10,resolution:"%"},blur:{title:"Title Shadow Blur",value:10,resolution:"%"},spread:{title:"Title Shadow Spread",value:10,resolution:"%"},shadowColor:{title:"Title Shadow Color",color:"rgba(221, 253, 253, 0.93)",colors:{color10:"rgba(46, 46, 44, 0.93)"},alpha:1}}   
        
//     }
//     ,typographySubtitle:{
//          titleColor:{title:"SubtTitle Text Color",color:"rgba(19, 19, 19, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},
    
//         size:{title:"SubtTitle Text Font Size",value:15,resolution:"px"},
//         family:{name:"OpenSans-Regular",
//     fontFamily:"OpenSansRegular , sans-serif"
//        },
//         weight:{title:"Title Text Font Weight",fontWeight:"100"},
//         textAlignment:{title:"Title Text Alignment",textAlign:"left"},
//         textCase:{title:"Title Text Case",textTransform:"capitalize"},
//        textStyle:{title:"Title  Text Style",textStyle:"normal"},
//       decoration:{title:"Subtitle Text Decoration",line:"none",style:"wavy",
//          decorationColor :{title:"Subtitle  Text Decoration Color",color:"rgba(19, 19, 19, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},thickness:{title:"Subtitle  Text Decoration Thickness",value:2,resolution:"px"}},
//        lineHeight:{title:"Title Text Line Height",value:30,resolution:"px"},
//        letterSpacing:{title:"Title Text Letter Spacing",value:2,resolution:"px"},
//        wordSpacing:{title:"Title Text Word Spacing",value:5,resolution:"px"},
//        textStroke:{ 
//          strokeColor:{title:"Title Text Stroke Color",color:"rgba(19, 19, 19, 0.93)",colors:{color2:"rgba(226, 240, 240, 0.93)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},
//          strokeSize:{title:"Title Text Stroke Size",value:0,resolution:"px"},
       
//               } ,
//                   textShadow:{title:"Title  Text Shadow",horizontal:{title:"Title Shadow Horizontal",value:0,resolution:"%"},vertical:{title:"Title Shadow Vertical",value:10,resolution:"%"},blur:{title:"Title Shadow Blur",value:10,resolution:"%"},spread:{title:"Title Shadow Spread",value:10,resolution:"%"},shadowColor:{title:"Title Shadow Color",color:"rgba(221, 253, 253, 0.93)",colors:{color10:"rgba(46, 46, 44, 0.93)"},alpha:1}}   
        
//     }
    
    
//  },  }



// ],
        
//         }

 const [relativeTop, setRelativeTop] = useState(0);
 const [scrollProgress, setScrollProgress] = useState(0);
 const [isVisible, setIsVisible] = useState(true);
 const [currentVideo, setCurrentVideo] = useState("");
   const [currentI, setCurrentI] = useState(0);
 const [videoPopUp, setVideoPopUp] = useState(false);
               let  myStyles=   {
 circleL:{ position:"absolute",right:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"50%",width:relativeTop? ` ${(scrollProgress*4 )}px `:'',height:relativeTop? ` ${(scrollProgress*4 )}px `:''},
 circleR:{ position:"absolute",left:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"50%",width:relativeTop? ` ${(scrollProgress*4 )}px `:'',height:relativeTop? ` ${(scrollProgress*4 )}px `:''},
 squareL:{ position:"absolute",right:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"0%",width:relativeTop? ` ${(scrollProgress*2 )}px `:'',height:relativeTop? ` ${(scrollProgress*2 )}px `:''},
 squareR:{ position:"absolute",left:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"0%",width:relativeTop? ` ${(scrollProgress*2 )}px `:'',height:relativeTop? ` ${(scrollProgress*2 )}px `:''},
 rectangleHR:{ position:"absolute", left:relativeTop? ` ${(scrollProgress*2 )}px `:"", borderRadius:"0%",width:relativeTop? ` ${(scrollProgress*3 )}px `:'',height:`100px`},
 rhombusHR:{ position:"absolute", left:relativeTop? ` ${(scrollProgress*2 )}px `:"",transform:"skewX(40deg)",width:relativeTop? ` ${(scrollProgress*3 )}px `:'',height:`100px`},
 rectangleHL:{ position:"absolute",right:relativeTop? ` ${(scrollProgress*3 )}px `:"", borderRadius:"0%",width:relativeTop? ` ${(scrollProgress*3 )}px `:'',height:`100px`},
 rhombusHL:{ position:"absolute",right:relativeTop? ` ${(scrollProgress*3 )}px `:"",transform:"skewX(40deg)",width:relativeTop? ` ${(scrollProgress*3 )}px `:'',height:`100px`},
       
          goUp:{transform:relativeTop? ` translateY(${(relativeTop*3 )}px) `:''},
         goDown:{transform:relativeTop? ` translateY(${(-relativeTop*3 )}px) `:''},
         goLeft:{transform:relativeTop>0? ` translateX(${(relativeTop*3 )}px) `:''},
         goRight:{transform:relativeTop>0? ` translateX(${(-relativeTop*3 )}px) `:''},
        
         zoomIn:{transform:relativeTop? `  scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
        zoomOut:{transform:relativeTop? `  scale(${(relativeTop>1?(relativeTop/100)*1:1 )}) `:''},
       
         skewVertical:{transform:relativeTop>0? ` rotateX(${(relativeTop<90&&relativeTop>0?relativeTop:0  )}deg) skewX(${(relativeTop<30&&relativeTop>0?relativeTop:0 )}deg) `:''},
         skewHorizontal:{transform:relativeTop>0? ` rotateY(${(relativeTop<90&&relativeTop>0?relativeTop:0  )}deg) skewY(${(relativeTop<30&&relativeTop>0?relativeTop:0 )}deg) `:''},
          
         flipVertical:{transform:relativeTop>0? `   rotateX(${(relativeTop<60?-relativeTop:0)}deg) `:''},
          flipHorizontal:{transform:relativeTop>0? `   rotateY(${(relativeTop<60?-relativeTop:0)}deg) `:''},
        spinLeft:{transform:relativeTop>0? `  rotateZ(${(relativeTop )}deg) `:''},
        spinRight:{transform:relativeTop>0? `  rotateZ(${(-relativeTop )}deg) `:''},
       
         slideUpZoom:{transform:relativeTop? ` translateY(${((relativeTop)*3 )}px) scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
         slideDownZoom:{transform:relativeTop? ` translateY(${((-relativeTop) )}px) scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
         slideLeftZoom:{transform:relativeTop>0? ` translateX(${(relativeTop*3 )}px) scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
         slideRightZoom:{transform:relativeTop>0? ` translateX(${(-relativeTop*3 )}px) scale(${((scrollProgress/100)*0.15 <1?(scrollProgress/100)*0.15:1 )}) `:''},
         
         slideUpSkew:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  skewX(${((relativeTop<60?relativeTop:0) )}deg) `:''},
        slideDownSkew:{transform:relativeTop>0? `  translateY(${(-relativeTop*3 )}px)  skewX(${((relativeTop<60?-relativeTop:0) )}deg) `:''},
        slideLeftSkew:{transform:relativeTop>0? `  translateX(${(relativeTop*3 )}px)  skewX(${((relativeTop<60?-relativeTop:0) )}deg) `:''},
        slideRightSkew:{transform:relativeTop>0? `  translateX(${(-relativeTop*3 )}px)  skewX(${((relativeTop<60?relativeTop:0) )}deg) `:''},
        
        slideUpRotate:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  rotateZ(${(relativeTop )}deg) `:''},
        slideDownRotate:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  rotateZ(${(-relativeTop )}deg) `:''},
        slideLeftRotate:{transform:relativeTop>0? `  translateX(${(relativeTop*3 )}px)  rotateZ(${((-relativeTop) )}deg) `:''},
        slideRightRotate:{transform:relativeTop>0? `  translateX(${(-relativeTop*3 )}px)  rotateZ(${(relativeTop )}deg) `:''},
       
        slideUpFlip:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  rotateY(${(relativeTop )}deg) `:''},
        slideDownFlip:{transform:relativeTop>0? `  translateY(${(relativeTop*3 )}px)  rotateY(${(-relativeTop )}deg) `:''},
        slideLeftFlip:{transform:relativeTop>0? `  translateX(${(relativeTop*3 )}px)  rotateY(${((-relativeTop) )}deg) `:''},
        slideRightFlip:{transform:relativeTop>0? `  translateX(${(-relativeTop*3 )}px)  rotateY(${(relativeTop )}deg) `:''},
       
  
          
        }






 function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }
       const fonts=[
  {name:"AlumniSansSC-Regular",
  fontFamily:"AlumniSansSCRegular , 'Helvetica Neue',sans-serif"
 }
 ,{name:"AlumniSansSC-Italic",
  fontFamily:"AlumniSansSCItalic , 'Helvetica Neue',sans-serif"
 }
,{name:"Inter-Regular",
  fontFamily:"InterRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Inter-Italic",
  fontFamily:"InterItalic , 'Helvetica Neue',sans-serif"
 }
,{name:"Lato-Light",
  fontFamily:"LatoLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Montserrat-Light",
  fontFamily:"MontserratLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Nunito-Light",
  fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
 }
,{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Poppins-Regular",
  fontFamily:"PoppinsRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Raleway-Light",
  fontFamily:"RalewayLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Raleway-Thin",
  fontFamily:"RalewayThin , 'Helvetica Neue',sans-serif"
 }

];
  const imagesList1 = [
                   { id: 1,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1747220093883-a5a198dea23a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8NXx8fGVufDB8fHx8fA%3D%3D" },
                 { id: 2,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1688891564708-9b2247085923?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                  { id: 3,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized ScheduleJoin Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1689551670902-19b441a6afde?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                { id: 4,hideImage: false, title: "Clear Your DoubtsClear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1664541336896-b3d5f7dec9a3?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                             { id: 5,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1689530775582-83b8abdb5020?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                  { id: 6,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                ];
                 const imagesList2 = [
                   { id: 1,hideImage: false, title: "1x1",subtitle: "Live Online Sessions", image: "https://plus.unsplash.com/premium_photo-1747220093883-a5a198dea23a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8NXx8fGVufDB8fHx8fA%3D%3D" },
                 { id: 2,hideImage: false, title: "Personalised",subtitle: "Result-Oriented Curriculum", image: "https://plus.unsplash.com/premium_photo-1688891564708-9b2247085923?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                  { id: 3,hideImage: false, title: "Performance",subtitle: "Opportunities to perform live", image: "https://plus.unsplash.com/premium_photo-1689551670902-19b441a6afde?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                { id: 4,hideImage: false, title: "Graded Syllabus",subtitle: "Join Live Classes With Customized Schedule", image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                { id: 5,hideImage: false, title: "Graded Syllabus",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1689530775582-83b8abdb5020?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"  },
                            ];
                const titleList1 = [
                   { id: 1,hideImage: false, title: "Only at ClasssMock!",subtitle: "Learn music & dance at your own pace through a personalized adaptive learning model that favors your interest and growth. Get a trusted result-oriented curriculum created by industry experts to accelerate your learning. You will also get multiple performance opportunities to boost your confidence and improve your technical skills.", image: "none" },
                       ];
  const  [cardObjectInn ,setCardObject] =useState(CurrentObject);
  
   const [isHovered, setIsHovered] = useState(false);
const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={`Theme1InfoCard2-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={`Theme1InfoCard2-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={`Theme1InfoCard2-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={`Theme1InfoCard2-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
    </div>
  );
};



const FullWidthCarousel = ({  setCurrentVideo,setVideoPopUp,progressColor,images, itemOuter }) => {
  const containerRef = useRef(null);  const containerRefTwo = useRef(null);
  const [currentI, setCurrentI] = useState(0);
const totalSlides = images.length;
const [progress, setProgress] = useState(0); // from 0 to 100

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentI((prevIndex) => (prevIndex + 1) % totalSlides);
  }, 3000); // Change slide every 3 seconds

  return () => clearInterval(interval); // cleanup on unmount
}, [totalSlides]);
useEffect(() => {
  if(currentI<=totalSlides-1){scrollToSlide(currentI);}else{scrollToSlide(0);}
 
 
}, [currentI]);
  const scroll = (direction) => {
    const container = containerRef?.current;
    const containerTwo = containerRefTwo?.current;
    if (container) {
     
     direction === "left" ?  setCurrentI((prevIndex) => (prevIndex - 1) % totalSlides) : setCurrentI((prevIndex) => (prevIndex + 1) % totalSlides);;
     
    }  if (containerTwo) {
     
     direction === "left" ?  setCurrentI((prevIndex) => (prevIndex - 1) % totalSlides) : setCurrentI((prevIndex) => (prevIndex + 1) % totalSlides);;
     
    }
  };
// Counter logic from 0 to 100 for each slide
useEffect(() => {
  setProgress(0); // reset when currentI changes

  const duration = 3000; // 3 seconds for full counter
  const stepTime = 30;   // update every 30ms
  const increment = 100 / (duration / stepTime); // e.g., ~1 per 30ms

  const counterInterval = setInterval(() => {
    setProgress((prev) => {
      const next = prev + increment;
      if (next >= 100) {
        clearInterval(counterInterval);
        return 100;
      }
      return next;
    });
  }, stepTime);

  return () => clearInterval(counterInterval); // cleanup
}, [currentI]);
  const scrollToSlide = (index) => {
    const container = containerRef?.current;
    if (container) {
      const width = container?.clientWidth;
      container.scrollTo({ left: width * index, behavior: "smooth" });
    
    } const containerTwo = containerRefTwo?.current;
    if (containerTwo) {
      const width = container?.clientWidth;
      containerTwo?.scrollTo({ left: width * index, behavior: "smooth" });
    
    }
  };

  return (<div className={`Theme1InfoCard2-card-${itemOuter?.myKey}`}>
  <div className={`Theme1InfoCard2-cardImages-${itemOuter?.myKey}`} style={{
  ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.layoutAnimation?.type:""],
  transition: `transform 0.1s ease-in-out, opacity 0.5s ease`,
}}>
    <div className={`carousel-wrapper-${itemOuter?.myKey}`}>
      <div className={`carousel-container-${itemOuter?.myKey}`} ref={containerRef}>
        {images.map((itemInner, index) => (
          <div className={`carousel-slide-${itemOuter?.myKey}`}key={index}>
            

            {!itemInner?.hideImage && (
              <div
                style={{
                  position: "relative",
                  top: "0px",
                  left: "0px",
                  right: "0px",
                  zIndex: "99",
                }}
              >
<div style={{display:"flex",justifyContent:"center",}}>
      <div onClick={()=>{setCurrentVideo(itemInner?.video);setVideoPopUp(true) 
      }}   className={`playButtonOuter-Theme1InfoCard2-${itemOuter?.myKey}`} style={{position:"absolute", alignItems:"center",cursor:"pointer"}} > 
      <div className={`playButtonInner-${itemOuter?.myKey}`} ></div>
       <Play strokeWidth={3}  size={45} style={{margin:"4px"}}  color="#fff"/>
          </div></div>
                 <div style={{...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item3Animation?.type:""],}}>
                <ImageFallFB  itemOuter={itemOuter}
                  boxShadow={`${itemOuter?.layoutSettings?.item1Shadow?.horizontal?.value}px ${itemOuter?.layoutSettings?.item1Shadow?.vertical?.value}px ${itemOuter?.layoutSettings?.item1Shadow?.blur?.value}px ${itemOuter?.layoutSettings?.item1Shadow?.spread?.value}px ${itemOuter?.layoutSettings?.item1Shadow?.shadowColor?.color} ${itemOuter?.layoutSettings?.item1Shadow?.inset ? "inset" : ""}`}
                  src={itemInner.image}
                  border={`${itemOuter?.layoutSettings?.item1Border?.borderWidth?.value}px ${itemOuter?.layoutSettings?.item1Border?.borderType} ${itemOuter?.layoutSettings?.item1Border?.borderColor?.color}`}
                  width={
                     100
                  }
                  aspectRatio={
                    itemOuter?.layoutSettings.item1AspectRatio?.value
                      ? itemOuter?.layoutSettings.item1AspectRatio?.value
                      : 1
                  }
                  borderRadius={
                    itemOuter?.layoutSettings?.borderRadius2 || {
                      value: 30,
                      resolution: "%",
                    }
                  }
                /></div>
              </div>
            )}
          </div>
        ))}

        {/* Buttons */}
        
      </div>


      {/* Dots */}
      <div className={`carousel-dots-${itemOuter?.myKey}`} style={{...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item5Animation?.type:""],background:`${itemOuter?.layoutSettings?.item2BG?.color}`}}>
 

  {images
    .slice(
      Math.max(0, currentI - 1),
      Math.min(images?.length, currentI + 3)
    )
    .map((itemInner, i) => {
      const realIndex = Math.max(0, currentI - 1) + i;
      return (
        <div
          key={realIndex}
          className={`dot-${itemOuter?.myKey} ${currentI === realIndex ? "" : ""}`}
          onClick={() => setCurrentI(realIndex)}
        >
          {currentI === realIndex?<div
            className={`squareboxkK-${itemOuter?.myKey}`}
            style={{   background:`#ffffff`,
                left:currentI === realIndex
                  ? `${progress}%`
                  : "", }}></div>:""}
        </div>
      );
    })}
</div>
    </div></div>
    
      <div className={`Theme1InfoCard2-cardRight-${itemOuter?.myKey}`} 
        //   onClick={()=>{setCurrentObject(itemOuter?.myKey,itemOuter);setCurrentContentIndex(parseInt(itemOuter?.contentNo)); }}
         style={{
  ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item3Animation?.type:""]
  
}} >
    
     <div className={`carousel-wrapper-${itemOuter?.myKey}`}>
      <div className={`carousel-container-${itemOuter?.myKey}`} ref={containerRefTwo}>
        {images.map((itemInner, index) => (
          <div className={`carousel-slide-${itemOuter?.myKey}`} key={index}>
            
            
            {!itemInner?.hideImage && (
              <div
                style={{
                  position: "relative",
                  top: "0px",
                  left: "0px",
                  right: "0px",
                  zIndex: "99",
                }}
              >

                <div style={{position:"relative",top:"50px",zIndex:"999",
  height:"400px"}}>
             <div style={{ ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item1Animation?.type:""],
             background:`${progressColor?.color10}`,padding:"10px 25px",
              borderTopLeftRadius:itemOuter?.layoutSettings?.borderRadius3?.topLeft?.value+itemOuter?.layoutSettings?.borderRadius3?.topLeft?.resolution,borderBottomLeftRadius:itemOuter?.layoutSettings?.borderRadius3?.bottomLeft?.value+itemOuter?.layoutSettings?.borderRadius3?.bottomLeft?.resolution,borderTopRightRadius:itemOuter?.layoutSettings?.borderRadius3?.topRight?.value+itemOuter?.layoutSettings?.borderRadius3?.topRight?.resolution,borderBottomRightRadius:itemOuter?.layoutSettings?.borderRadius3?.bottomRight?.value+itemOuter?.layoutSettings?.borderRadius3?.bottomRight?.resolution}}> <div className={`Theme1InfoCard2-cardRight-title-${itemOuter?.myKey}  ${itemOuter?.layoutSettings?.titleEllipsis?.status?`Theme1InfoCard2-cardRight-title-ellipsis-${itemOuter?.myKey}`:``}`} 
              style={{
             
  
    fontSize: `${itemOuter?.layoutSettings?.typographyTitle?.size?.value}${itemOuter?.layoutSettings?.typographyTitle?.size?.resolution}`,
    fontFamily: `${itemOuter?.layoutSettings?.typographyTitle?.family?.fontFamily}`,
    fontWeight: `${itemOuter?.layoutSettings?.typographyTitle?.weight?.fontWeight}`,
    textAlign: `${itemOuter?.layoutSettings?.typographyTitle?.textAlignment?.textAlign}`,
    textTransform: `${itemOuter?.layoutSettings?.typographyTitle?.textCase?.textTransform}`,
    fontStyle: `${itemOuter?.layoutSettings?.typographyTitle?.textStyle?.textStyle}`,
   textDecoration: `${itemOuter?.layoutSettings?.typographyTitle?.decoration?.line}  ${itemOuter?.layoutSettings?.typographyTitle?.decoration?.style} ${itemOuter?.layoutSettings?.typographyTitle?.decoration?.decorationColor?.color} ${itemOuter?.layoutSettings?.typographyTitle?.decoration?.thickness?.value}${itemOuter?.layoutSettings?.typographyTitle?.decoration?.thickness?.resolution}`,
      lineHeight: `${itemOuter?.layoutSettings?.typographyTitle?.lineHeight?.value}${itemOuter?.layoutSettings?.typographyTitle?.lineHeight?.resolution}`,
   letterSpacing: ` ${itemOuter?.layoutSettings?.typographyTitle?.letterSpacing?.value}${itemOuter?.layoutSettings?.typographyTitle?.letterSpacing?.resolution}`,
    wordSpacing: ` ${itemOuter?.layoutSettings?.typographyTitle?.wordSpacing?.value}${itemOuter?.layoutSettings?.typographyTitle?.wordSpacing?.resolution}`,
    
    WebkitTextStroke: `${itemOuter?.layoutSettings?.typographyTitle?.textStroke?.strokeSize?.value}px ${itemOuter?.layoutSettings?.typographyTitle?.textStroke?.strokeColor?.color}`,
   
     }}
       
          > {<TrimmedTextUI text={itemInner?.title} />}</div> </div> 

          <div className={`Theme1InfoCard2-cardRight-description-${itemOuter?.myKey} 
            ${itemOuter?.layoutSettings.subtitleEllipsis?.status?`Theme1InfoCard2-cardRight-description-ellipsis-${itemOuter?.myKey}`:``}`}
              style={{ ...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item2Animation?.type:""],
 padding:"5px 25px",marginTop:"20px",
    fontSize: `${itemOuter?.layoutSettings?.typographySubtitle?.size?.value}${itemOuter?.layoutSettings?.typographySubtitle?.size?.resolution}`,
    fontFamily: `${itemOuter?.layoutSettings?.typographySubtitle?.family?.fontFamily}`,
    fontWeight: `${itemOuter?.layoutSettings?.typographySubtitle?.weight?.fontWeight}`,
    textAlign: `${itemOuter?.layoutSettings?.typographySubtitle?.textAlignment?.textAlign}`,
    textTransform:`${itemOuter?.layoutSettings?.typographySubtitle?.textCase?.textTransform}`,
    fontStyle: `${itemOuter?.layoutSettings?.typographySubtitle?.textStyle?.textStyle}`,
    textDecoration: `${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.line}  ${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.style} ${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.decorationColor?.color} ${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.thickness?.value}${itemOuter?.layoutSettings?.typographySubtitle?.decoration?.thickness?.resolution}`,
    lineHeight: ` ${itemOuter?.layoutSettings?.typographySubtitle?.lineHeight?.value}${itemOuter?.layoutSettings?.typographySubtitle?.lineHeight?.resolution}`,
    letterSpacing: ` ${itemOuter?.layoutSettings?.typographySubtitle?.letterSpacing?.value}${itemOuter?.layoutSettings?.typographySubtitle?.letterSpacing?.resolution}`,
    wordSpacing: ` ${itemOuter?.layoutSettings?.typographySubtitle?.wordSpacing?.value}${itemOuter?.layoutSettings?.typographySubtitle?.wordSpacing?.resolution}`,
    WebkitTextStroke: ` ${itemOuter?.layoutSettings?.typographySubtitle?.textStroke?.strokeSize?.value}${itemOuter?.layoutSettings?.typographySubtitle?.textStroke?.strokeSize?.resolution}  ${itemOuter?.layoutSettings?.typographySubtitle?.textStroke?.strokeColor?.color}`,
              }}
          
          > {<TrimmedTextUI text={itemInner?.subtitle} />}</div> 

                </div>
                
                
              </div>
            )}
          </div>
        ))}

        {/* Buttons */}
        
      </div>

<div className={`carousel-SlideNo-${itemOuter?.myKey}`} style={{...myStyles[!itemOuter?.layoutSettings?.disableAnimation?itemOuter?.layoutSettings?.item4Animation?.type:""],background:`${itemOuter?.layoutSettings?.item2BG?.color}`}}>
  <h3><span style={{fontSize:"40px", fontFamily: `${itemOuter?.layoutSettings?.typographySubtitle?.family?.fontFamily}`,}}>{currentI+1}</span>/{totalSlides}</h3>
</div>
     
    </div> </div>
    
    </div>
  );
};





return(<>
{}
  <ScrollTransformWrapper 
  setRelativeTop={(relativeTop)=>{setRelativeTop(relativeTop)}}
  setIsVisible={(isVisible)=>{setIsVisible(isVisible)}}
  setScrollProgress={(scrollProgress)=>{setScrollProgress(scrollProgress)}}
  containerId="scrollContainerId"
        maxTranslate={100}
        maxRotate={0}
        maxScale={1.1}
        customStyleFn={({ scale }) => ({
          myStyles:myStyles,
          transition: "transform 0.2s ease-in-out",
        })}
      >
        
       {videoPopUp?<>
       <div     style={{zIndex:99,cursor:"pointer"}} onClick={()=>setVideoPopUp(false)} className={`videoPlayerPopUpBackDrop-${CurrentObject?.contents[1]?.myKey}`}> </div>
        <div   className={`videoPlayerPopUpMain-${CurrentObject?.contents[1]?.myKey}`} style={{height:"400px",borderRadius: '20px'}}> 
  <div style={{position:"relative"}}>
    <div  style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",right:"0px",margin:"10px",position:"absolute",
      background:`${CurrentObject?.contents[1]?.layoutSettings?.item1BG?.color}`,zIndex:99999999999999}} onClick={()=>{setVideoPopUp(false)}}   >
        <X  style={{padding:"9px",}} color="#fff" size={22}/></div>
    </div> 
       {currentVideo?.sourceType=="youtube"?<YoutubeVideoPlayerWebUI  videoSettings={currentVideo} videoId={currentVideo?.youtube?.src} minHeight={400} maxHeight={400}/>:""}
      
 </div>
       </>:""}
<div   className="hoverItemElementInner" onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)} 
      style={{
position:"relative",border:dynamicId==CurrentObject?.myKey?"2px solid rgba(144, 202, 249,1)":isHovered?"2px solid rgba(144, 202, 249,1)":"2px solid transparent",
          margin:"0px",marginTop:"25px",overflow:"hidden"}} >{}
           
     
                   
      <div >
      
       
      
         {CurrentObject?.contents.map((itemOuter,indexOuter)=>(<>
      
       {indexOuter==1?<>
       <div onClick={()=>{setCurrentObject(itemOuter?.myKey,itemOuter);setCurrentContentIndex(parseInt(itemOuter?.contentNo)); }} className={isHovered?"":""}   style={{height:"50px",width:"100%",position:"absolute",top:"35px",left:"220px",zIndex:"999999",
        transform:"scale(1.3)"
      }}>
       
             {dynamicId==itemOuter?.myKey? <div   style={{position:"absolute",top:"-12px",left:"0px",fontSize:"12px",width:"73px",height:"25px",borderRadius:"5px"}}> <div style={{position:"absolute",top:"0px",left:"0px",right:"0px",bottom:"0px"}}><div className="ElementSettingsItem"  style={{display:"flex",justifyContent:"space-between",position:"absolute",top:"-0.1px",left:"-1.08px",fontSize:"12px",width:"60px",height:"15px",paddingRight:"5px",}}> <CheckCheck size={12}  color="#333" /> Selected</div></div></div>:
              
                <div   style={{position:"absolute",top:"12px",left:"0px",fontSize:"12px",width:"73px",height:"25px",borderRadius:"5px"}}> <div style={{position:"absolute",top:"0px",left:"0px",right:"0px",bottom:"0px"}}><div className="ElementSettingsItem"  style={{display:"flex",justifyContent:"space-between",position:"absolute",top:"-0.1px",left:"-1.08px",fontSize:"12px",width:"60px",height:"15px",paddingRight:"5px",}}> <Pencil size={12}  color="#333" /> Edit </div></div></div>}  
          
             
                </div>
        
      
<FullWidthCarousel setVideoPopUp={(videoPopUp)=>{setVideoPopUp(videoPopUp)}}
setCurrentISend={(currentI)=>{setCurrentI((prevIndex) => currentI)}}
 setCurrentVideo={(currentVideo)=>{setCurrentVideo(currentVideo)}}
  progressColor={CurrentObject?.contents[1]?.layoutSettings?.item1BG?.colors} images={itemOuter?.itemCards?.cards}  itemOuter={itemOuter} />
      
        
     

        
        </>:""}</>))}
        
     
     
      </div> </div></ScrollTransformWrapper>
      
      <style>{ CurrentObject?.contents?.map((item,index)=>(`
      .videoPlayerPopUpBackDrop-${item?.myKey}{position:fixed;top:0px;
        left:0px;
        right:0px;
       
        bottom:0px;
        padding:15px;
        background:rgba(1, 1, 1,0.661);
        z-index:99999999 !important}
        .videoPlayerPopUpMain-${item?.myKey}{position:fixed;top:0px;
    left:20%;
    right:20%;
    background: linear-gradient(to right, #fff,#f5f5f5, #fff, #fff);
    top:15%;
    padding:15px;
    z-index:99999999 !important;}
.carousel-dots-${item?.myKey} {padding:10px;margin:10px; 
  border-top-left-radius:${item?.layoutSettings?.borderRadius2?.topLeft?.value+"px"};
    border-bottom-left-radius:${item?.layoutSettings?.borderRadius2?.bottomLeft?.value+"px"};
    border-top-right-radius:${item?.layoutSettings?.borderRadius2?.topRight?.value+"px"};
    border-bottom-right-radius:${item?.layoutSettings?.borderRadius2?.bottomRight?.value+"px"};
   
        
  text-align: center;
  width:340px;
  
  position:absolute;
  ${item?.layoutSettings?.mirrorItems?.status?"right:0px !important;":"left:0px !important;"}
  bottom:${item?.layoutSettings?.marginItem2?.marginBottom?.value}%;
           
  z-index:999999!important;
  margin-top: 10px;
}.carousel-SlideNo-${item?.myKey} {padding:10px;margin:10px; 

 border-top-left-radius:${item?.layoutSettings?.borderRadius2?.topLeft?.value+"px"};
    border-bottom-left-radius:${item?.layoutSettings?.borderRadius2?.bottomLeft?.value+"px"};
    border-top-right-radius:${item?.layoutSettings?.borderRadius2?.topRight?.value+"px"};
    border-bottom-right-radius:${item?.layoutSettings?.borderRadius2?.bottomRight?.value+"px"};
 
  text-align: center;width:50px;position:absolute;right:-10px ;top:-30px;z-index:999999!important;
  margin-top: 10px;
}
.squareboxkK-${item?.myKey} {
    width: 10px;
    height: 10px;
    border-radius: 0%;
   
    display: flex;
    align-items: center;
    justify-content: center;
    position:relative;
  }
.dot-${item?.myKey} {
  display: inline-block;
  height: 10px;
  width: 70px;
  margin: 5px 10px;
 
  border-radius: 0%;
  cursor: pointer;background: #333;
  transition: background 0.3s;
}


    .carousel-wrapper-${item?.myKey} {
  position: relative;
  
  width: 100%;
}

.carousel-container-${item?.myKey} {
  display: flex;
  overflow-x: auto; overflow-y:hidden !important;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  width: 100%;
}

.carousel-container-${item?.myKey}::-webkit-scrollbar {
  display: none;
}

.carousel-slide-${item?.myKey} {
  flex: 0 0 100%;
  scroll-snap-align: start;
  position: relative;
}

.carousel-slide-${item?.myKey} img {
  width: 100%;
  height: auto;
  display: block;
}


.playButtonOuter-Theme1InfoCard2-${item?.myKey}{
 position: absolute;
    
    color: white;z-index:999 !important;
    padding: 18px;background:${item?.layoutSettings?.item2BG?.color};
    border-top-left-radius:${item?.layoutSettings?.borderRadius2?.topLeft?.value+"px"};
    border-bottom-left-radius:${item?.layoutSettings?.borderRadius2?.bottomLeft?.value+"px"};
    border-top-right-radius:${item?.layoutSettings?.borderRadius2?.topRight?.value+"px"};
    border-bottom-right-radius:${item?.layoutSettings?.borderRadius2?.bottomRight?.value+"px"};
      width:${item?.layoutSettings.item1Width?.value?item?.layoutSettings.item1Width?.value:100}px;
             box-shadow:${item?.layoutSettings?.item1Shadow?.horizontal?.value}px ${item?.layoutSettings?.item1Shadow?.vertical?.value}px ${item?.layoutSettings?.item1Shadow?.blur?.value}px ${item?.layoutSettings?.item1Shadow?.spread?.value}px ${item?.layoutSettings?.item1Shadow?.shadowColor?.color} ${item?.layoutSettings?.item1Shadow?.inset?"inset":""};
            bottom:${item?.layoutSettings?.marginItem1?.marginBottom?.value}%;
              padding-top:${item?.layoutSettings?.paddingItem1?.paddingTop?.value}${item?.layoutSettings?.paddingItem1?.paddingTop?.resolution};
            padding-bottom:${item?.layoutSettings?.paddingItem1?.paddingBottom?.value}${item?.layoutSettings?.paddingItem1?.paddingBottom?.resolution};
            padding-left:${item?.layoutSettings?.paddingItem1?.paddingLeft?.value}${item?.layoutSettings?.paddingItem1?.paddingLeft?.resolution};
            padding-right:${item?.layoutSettings?.paddingItem1?.paddingRight?.value}${item?.layoutSettings?.paddingItem1?.paddingRight?.resolution};
      
    height: 50px;
      }
.playButtonInner-${item?.myKey}{animation: PlayButtonAnim 2.8s infinite linear;
  border:7px solid rgba(256, 256, 256, 0.50302);
  z-index:999 !important;
  position: absolute;top:3px;left:0px;right:0px;bottom: 0px;
  padding: 18px;
   border-top-left-radius:${item?.layoutSettings?.borderRadius2?.topLeft?.value+"px"};
    border-bottom-left-radius:${item?.layoutSettings?.borderRadius2?.bottomLeft?.value+"px"};
    border-top-right-radius:${item?.layoutSettings?.borderRadius2?.topRight?.value+"px"};
    border-bottom-right-radius:${item?.layoutSettings?.borderRadius2?.bottomRight?.value+"px"};
   
  width: 35px; 
  height: 35px;}
@keyframes PlayButtonAnim{
  0% {
      /* opacity: 0; */
      transform: scale(1.4)
  }
  50% {
      transform: scale(0.81)
  }
 
  100% {
      transform: scale(1.4)
  }
  }
        .Theme1InfoCard2-card-${item?.myKey} {
        position:relative;
          background:${item?.layoutSettings?.layoutBG?.color};
           width:${item?.layoutSettings?.layoutWidth?.value}%;
          display: ${"flex"};
         flex-direction:${item?.layoutSettings?.flexDirection};
         flex-wrap:${item?.layoutSettings?.flexWrap};
          
          justify-content:${item?.layoutSettings?.justifyContent};
         align-items:${item?.layoutSettings?.alignItems};
          gap:  ${item?.layoutSettings?.gap}px;
           margin-top:${item?.layoutSettings?.margin?.marginTop?.value}${item?.layoutSettings?.margin?.marginTop?.resolution};
            margin-bottom:${item?.layoutSettings?.margin?.marginBottom?.value}${item?.layoutSettings?.margin?.marginBottom?.resolution};
            margin-left:${item?.layoutSettings?.margin?.marginLeft?.value}${item?.layoutSettings?.margin?.marginLeft?.resolution};
            margin-right:${item?.layoutSettings?.margin?.marginRight?.value}${item?.layoutSettings?.margin?.marginRight?.resolution};
           padding-top:${item?.layoutSettings?.padding?.paddingTop?.value}${item?.layoutSettings?.padding?.paddingTop?.resolution};
            padding-bottom:${item?.layoutSettings?.padding?.paddingBottom?.value}${item?.layoutSettings?.padding?.paddingBottom?.resolution};
            padding-left:${item?.layoutSettings?.padding?.paddingLeft?.value}${item?.layoutSettings?.padding?.paddingLeft?.resolution};
            padding-right:${item?.layoutSettings?.padding?.paddingRight?.value}${item?.layoutSettings?.padding?.paddingRight?.resolution};
      
         
          box-shadow:${item?.layoutSettings?.layoutShadow?.horizontal?.value}px ${item?.layoutSettings?.layoutShadow?.vertical?.value}px ${item?.layoutSettings?.layoutShadow?.blur?.value}px ${item?.layoutSettings?.layoutShadow?.spread?.value}px ${item?.layoutSettings?.layoutShadow?.shadowColor?.color} ${item?.layoutSettings?.layoutShadow?.inset?"inset":""};
        border:${item?.layoutSettings?.layoutBorder?.borderWidth?.value}px ${item?.layoutSettings?.layoutBorder?.borderType} ${item?.layoutSettings?.layoutBorder?.borderColor?.color};
           box-shadow:${item?.layoutSettings?.layoutShadow?.horizontal?.value}px ${item?.layoutSettings?.layoutShadow?.vertical?.value}px ${item?.layoutSettings?.layoutShadow?.blur?.value}px ${item?.layoutSettings?.layoutShadow?.spread?.value}px ${item?.layoutSettings?.layoutShadow?.shadowColor?.color} ${item?.layoutSettings?.layoutShadow?.inset?"inset":""};

     
          
        }
          .Theme1InfoCard2-card-BG${item?.myKey} {
           position:absolute;left:0px;right:0px;bottom:0px;top:0px;
          
         
       
        }
          

          .Theme1InfoCard2-card-${item?.myKey}:hover {
         
         
         
        }
          .Theme1InfoCard2-cardImages-${item?.myKey} {
         
            width:60%;
          
  margin-top:${item?.layoutSettings?.marginItem1?.marginTop?.value}${item?.layoutSettings?.marginItem1?.marginTop?.resolution};
            margin-bottom:${item?.layoutSettings?.marginItem1?.marginBottom?.value}${item?.layoutSettings?.marginItem1?.marginBottom?.resolution};
            margin-left:${item?.layoutSettings?.marginItem1?.marginLeft?.value}${item?.layoutSettings?.marginItem1?.marginLeft?.resolution};
            margin-right:${item?.layoutSettings?.marginItem1?.marginRight?.value}${item?.layoutSettings?.marginItem1?.marginRight?.resolution};
           padding-top:${item?.layoutSettings?.paddingItem1?.paddingTop?.value}${item?.layoutSettings?.paddingItem1?.paddingTop?.resolution};
            padding-bottom:${item?.layoutSettings?.paddingItem1?.paddingBottom?.value}${item?.layoutSettings?.paddingItem1?.paddingBottom?.resolution};
            padding-left:${item?.layoutSettings?.paddingItem1?.paddingLeft?.value}${item?.layoutSettings?.paddingItem1?.paddingLeft?.resolution};
            padding-right:${item?.layoutSettings?.paddingItem1?.paddingRight?.value}${item?.layoutSettings?.paddingItem1?.paddingRight?.resolution};
              
       
        }
 
.Theme1InfoCard2-cardRight-${item?.myKey} {
          
           
           width:40%;
          
          
          padding:10px;
           margin-top:${item?.layoutSettings?.marginItem2?.marginTop?.value}${item?.layoutSettings?.marginItem2?.marginTop?.resolution};
            margin-bottom:${item?.layoutSettings?.marginItem2?.marginBottom?.value}${item?.layoutSettings?.marginItem2?.marginBottom?.resolution};
            margin-left:${item?.layoutSettings?.marginItem2?.marginLeft?.value}${item?.layoutSettings?.marginItem2?.marginLeft?.resolution};
            margin-right:${item?.layoutSettings?.marginItem2?.marginRight?.value}${item?.layoutSettings?.marginItem2?.marginRight?.resolution};
           padding-top:${item?.layoutSettings?.paddingItem2?.paddingTop?.value}${item?.layoutSettings?.paddingItem2?.paddingTop?.resolution};
            padding-bottom:${item?.layoutSettings?.paddingItem2?.paddingBottom?.value}${item?.layoutSettings?.padding?.paddingBottom?.resolution};
            padding-left:${item?.layoutSettings?.paddingItem2?.paddingLeft?.value}${item?.layoutSettings?.paddingItem2?.paddingLeft?.resolution};
            padding-right:${item?.layoutSettings?.paddingItem2?.paddingRight?.value}${item?.layoutSettings?.paddingItem2?.paddingRight?.resolution};
            border:${item?.layoutSettings?.item2Border?.borderWidth?.value}px ${item?.layoutSettings?.item2Border?.borderType} ${item?.layoutSettings?.item2Border?.borderColor?.color};
           box-shadow:${item?.layoutSettings?.item2Shadow?.horizontal?.value}px ${item?.layoutSettings?.item2Shadow?.vertical?.value}px ${item?.layoutSettings?.item2Shadow?.blur?.value}px ${item?.layoutSettings?.item2Shadow?.spread?.value}px ${item?.layoutSettings?.item2Shadow?.shadowColor?.color} ${item?.layoutSettings?.item2Shadow?.inset?"inset":""};
   
        border-top-left-radius:${item?.layoutSettings?.borderRadius3?.topLeft?.value+"px"};
    border-bottom-left-radius:${item?.layoutSettings?.borderRadius3?.bottomLeft?.value+"px"};
    border-top-right-radius:${item?.layoutSettings?.borderRadius3?.topRight?.value+"px"};
    border-bottom-right-radius:${item?.layoutSettings?.borderRadius3?.bottomRight?.value+"px"};
        }

.Theme1InfoCard2-CardImage-wrapper${item?.myKey} {

position:absolute;z-index:99999;
width:95px;height:95px;
   
}
  
       
         
.Theme1InfoCard2-cardRight-title-${item?.myKey} {
        z-index:999;
        background: ${item?.layoutSettings?.typographyTitle?.titleColor?.color};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  background-clip: text;
  color: transparent;
          
     white-space: ${item?.layoutSettings.titleEllipsis?.status?"nowrap":"none"};
    overflow:  ${item?.layoutSettings.titleEllipsis?.status?"hidden":"none"};
    text-overflow: ${item?.layoutSettings.titleEllipsis?.status?"ellipsis":"none"} ;;

   
        }

        .Theme1InfoCard2-cardRight-description-${item?.myKey} {
          font-size: 0.85rem;position:relative;z-index:999;
           background: ${item?.layoutSettings?.typographySubtitle?.titleColor?.color};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  background-clip: text;
  color: transparent;
          
     white-space: ${item?.layoutSettings.subtitleEllipsis?.status?"nowrap":"none"};
    overflow:  ${item?.layoutSettings.subtitleEllipsis?.status?"hidden":"none"};
    text-overflow: ${item?.layoutSettings.subtitleEllipsis?.status?"ellipsis":"none"} ;;
   }
           .Theme1InfoCard2-cardRight-description-ellipsis-${item?.myKey} {
         white-space: nowrap;
    overflow:  hidden;
    text-overflow: ellipsis
      } .Theme1InfoCard2-cardRight-title-ellipsis-${item?.myKey} {
        
           white-space: nowrap;
    overflow:  hidden;
    text-overflow: ellipsis
      }

/* md */
@media (min-width: 992px) and (max-width: 1199px) {
 .playButtonOuter-Theme1InfoCard2-${item?.myKey}{
 bottom:70px !important;left:70% !important; transform:scale(0.7)
    
      }
  .videoPlayerPopUpMain-${item?.myKey}{position:fixed;top:0px;
                left:10%;
                right:10%;top:100px;
               } 
 }
/* sm */
@media (min-width: 768px) and (max-width: 991px) {
.Theme1InfoCard2-card-${item?.myKey} { flex-direction:column;}
  .Theme1InfoCard2-cardImages-${item?.myKey} { width:100%;margin:0px}
  .carousel-dots-${item?.myKey} { width:320px; bottom:0px; transform:scale(0.7)}
   .playButtonOuter-Theme1InfoCard2-${item?.myKey}{
 bottom:-100px !important; transform:scale(0.7)
    
      }
  .videoPlayerPopUpMain-${item?.myKey}{position:fixed;
                left:10%;
                right:10%;top:100px;
               } 
  }
                                   /* xs */
@media (max-width: 767px) {
 .Theme1InfoCard2-card-${item?.myKey} { flex-direction:column; margin-bottom:0px !important}

 .Theme1InfoCard2-cardRight-${item?.myKey} {width:100% !important;margin:0px !important;}
 
  .Theme1InfoCard2-cardImages-${item?.myKey} { width:100%;margin:0px !important}
    .Theme1InfoCard2-CardImage-AspectRatioXs${item?.myKey} { aspect-ratio:1/1 !important;}
    .Theme1InfoCard2-cardRight-title-${item?.myKey} {line-height:30px  !important; ; ;top:32px,left:0px !important;right:0px !important;}
  .Theme1InfoCard2-cardRight-description-${item?.myKey} { font-size: 0.7rem !important;;width:100%;top:8px;}
  .Theme1InfoCard2-cardRight-title-${item?.myKey} {font-size: 1.4rem  !important; ;}
  .Theme1InfoCard2-card-BG${item?.myKey} {height:300px; }
  .carousel-dots-${item?.myKey} { width:320px; bottom:-20px; transform:scale(0.7)}

  .carousel-SlideNo-${item?.myKey} { border-radius:15px;transform:scale(0.7);
  left:75% !important;
}
  .playButtonOuter-Theme1InfoCard2-${item?.myKey}{
 bottom:70px !important;transform:scale(0.7);
    
      }
  .videoPlayerPopUpMain-${item?.myKey}{position:fixed;top:0px;
                left:0%;
                right:0%;top:0px; bottom:0px!important;
               } 
}
 
      `))}</style>
  
</>)
}
export default Theme1InfoCard2;